// import { useEffect, useState } from "react";
// import "../../scss/reactSidebar.scss";
// import { Sidebar, useProSidebar } from "react-pro-sidebar";
// import { AiOutlineArrowRight } from "react-icons/ai";
// import Piechart from "../Charts/Piechart";
// import * as XLSX from "xlsx";
// import { formatSalesValue } from "../../utils/formatUtils";

// const SidebarPro = ({
//   dineinTabs,
//   paymentStatus,
//   splitDetails,
//   startBillNum,
//   endBillNum,
//   FoodBeverageSum,
//   toggleArrow,
//   outlet
// }) => {
//   const [totalSplitCash, setTotalSplitCash] = useState(0);
//   const [totalSplitCreditCard, setTotalSplitCreditCard] = useState(0);
//   const [totalSplitMobilePayment, setTotalMobilePayment] = useState(0);

//   const { collapseSidebar } = useProSidebar();

//   if (!dineinTabs?.error) {
//     const netTotalSale = dineinTabs.netTOTALSALES;
//     const numGuest = dineinTabs.TotalGuests;
//     var revenuePerGuest = netTotalSale / numGuest;
//   }

//   useEffect(() => {
//     if (Array.isArray(splitDetails)) {
//       splitDetails.forEach((payment) => {
//         if (payment.paymentMode === "Cash") {
//           setTotalSplitCash(payment.paymentAmount);
//         } else if (payment.paymentMode === "Credit Card") {
//           setTotalSplitCreditCard(payment.paymentAmount);
//         } else if (payment.paymentMode === "Mobile Payment") {
//           setTotalMobilePayment(payment.paymentAmount);
//         }
//       });
//     }
//   }, [splitDetails]);

//   const handleExport = () => {
//     if (!dineinTabs) return;

//     const data = [
//       ["Starting Bill No", startBillNum],
//       ["Ending Bill No", endBillNum || "-"],
//       ["Total Guests", dineinTabs.TotalGuests || "-"],
//       ["Revenue Per Guest", revenuePerGuest?.toFixed(2) || "-"],
//       [],
//       ["Total Sales", dineinTabs.TOTALSALES],
//       ["Dine-In", dineinTabs.DineInSALES],
//       ["Take-away", dineinTabs.TabSALES || 0],
//       [],
//       ["Total Net Sales", dineinTabs.netTOTALSALES],
//       ["Dine-In", dineinTabs.netDineInSALES],
//       ["Take-away", dineinTabs.netTabSALES || 0],
//       [],
//       ["Total VAT", dineinTabs.TotalVat],
//       ["Dine-In VAT", dineinTabs.DineInVAT],
//       ["Take-away VAT", dineinTabs.TabVAT || 0],
//       [],
//       ["Food Sale", dineinTabs.FoodSale],
//       ["Beverage Sale", dineinTabs.BeverageSale],
//       ["Others", dineinTabs.OtherSale || 0],
//       [],
//       ["Credit Card", parseInt(paymentStatus.CreditCard || 0) + totalSplitCreditCard],
//       ["Cash", parseInt(paymentStatus.Cash || 0) + totalSplitCash],
//       ["Mobile Payment", parseInt(paymentStatus.MobilePayment || 0) + totalSplitMobilePayment],
//       ["Credit", paymentStatus.Credit],
//       ["Complimentary", paymentStatus.Complimentary],
//       ["Discount", dineinTabs.DiscountAmountSum]
//     ];

//     const ws = XLSX.utils.aoa_to_sheet(data);

//     const colWidths = data[0].map((_, colIndex) => {
//       const maxLen = data.reduce((max, row) => {
//         const cell = row[colIndex];
//         const len = cell ? cell.toString().length : 0;
//         return Math.max(max, len);
//       }, 10);

//       return { wch: maxLen + 4 };
//     });

//     ws["!cols"] = colWidths;

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Summary");

//     // ---------- Dynamic filename ----------
//     const today = new Date().toLocaleDateString('en-CA');
//     const safeOutlet = (outlet || "Outlet")
//       .replace(/[^a-z0-9]/gi, "_")
//       .toLowerCase();

//     const filename = `${safeOutlet}_sales_${today}.xlsx`;

//     XLSX.writeFile(wb, filename);
//   };

//   return (
//     <div className="sidebar">
//       <main onClick={toggleArrow}>
//         <button onClick={() => collapseSidebar()} className="btn-sidebar">
//           {<AiOutlineArrowRight className="icon-arrow" />}
//         </button>
//       </main>
//       <Sidebar>
//         <div>
//           {!dineinTabs?.error && (
//             <div className="dine-tabs-list text-base">
//               <div className="flex justify-end p-2">
//                 <button
//                   onClick={handleExport}
//                   className="export text-sm"
//                 >
//                   Export
//                 </button>
//               </div>

//               <div className="bill-no space-y-2 p-3">
//                 <div className="start-bill-no">
//                   <label>
//                     <span>Starting Bill No : </span>
//                     {startBillNum}
//                   </label>
//                 </div>
//                 <div className="end-bill-no">
//                   <label>
//                     <span>Ending Bill No : </span>
//                     {endBillNum === "" ? "-" : endBillNum}
//                   </label>
//                 </div>
//                 <div className="total-guest">
//                   <label>
//                     <span>Total No. of Guest : </span>
//                     {dineinTabs.TotalGuests === ""
//                       ? "-"
//                       : dineinTabs.TotalGuests}
//                   </label>
//                 </div>
//                 <div className="revenue">
//                   <label>
//                     <span>Revenue Per Guest : </span>
//                     {revenuePerGuest === "" ? "-" : revenuePerGuest.toFixed(2)}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="total-info space-y-2 p-3">
//                 <label>
//                   {" "}
//                   <span>Total Sales : </span> {formatSalesValue(dineinTabs.TOTALSALES)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInSALES)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {!dineinTabs.TabSALES ? "0" : formatSalesValue(dineinTabs.TabSALES)}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="total-info space-y-2 p-3">
//                 <label>
//                   {" "}
//                   <span>Total Net Sales : </span>
//                   {formatSalesValue(dineinTabs.netTOTALSALES)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.netDineInSALES)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {!dineinTabs.netTabSALES ? "0" : dineinTabs.netTabSALES}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="total-info space-y-2 p-3">
//                 <label>
//                   {" "}
//                   <span>Total VAT: </span>
//                   {formatSalesValue(dineinTabs.TotalVat)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInVAT)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {(dineinTabs.TabVAT = dineinTabs.TabVAT ?? "0")}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="total-info space-y-2 p-3">
//                 <label>
//                   {" "}
//                   <span>Service Charge : </span>
//                   {formatSalesValue(dineinTabs.TotalServiceCharge)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInServiceCharge)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {
//                       (dineinTabs.TabServiceCharge =
//                         dineinTabs.TabServiceCharge ?? "0")
//                     }
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="py-3">
//                 <Piechart
//                   FoodBeverageSum={FoodBeverageSum}
//                   dineinTabs={dineinTabs}
//                 />
//               </div>

//               <hr className="hr-line" />

//               <div className="total-info space-y-2 p-3">
//                 <label>
//                   {" "}
//                   <span>Food Sale : </span>
//                   {formatSalesValue(dineinTabs.FoodSale)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Beverage Sale : </span>
//                     {formatSalesValue(dineinTabs.BeverageSale)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Others : </span>
//                     {!dineinTabs.OtherSale ? "0:00" : dineinTabs.OtherSale}
//                   </label>
//                 </div>
//               </div>
//               <hr className="hr-line" />
//             </div>
//           )}
//           {!paymentStatus?.error && (
//             <div className="dine-tabs-paymemnt-status space-y-2 p-3">
//               <div>
//                 <label>
//                   <span>Credit Card : </span>
//                   {formatSalesValue(
//                     Number(paymentStatus.CreditCard) + totalSplitCreditCard
//                   )}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span>Cash : </span>
//                   {formatSalesValue(Number(paymentStatus.Cash) + totalSplitCash)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span> Mobile Payment : </span>
//                   {formatSalesValue(Number(paymentStatus.MobilePayment) + totalSplitMobilePayment)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   {" "}
//                   <span>Credit Sale: </span>
//                   {formatSalesValue(paymentStatus.Credit)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span>Complimentary : </span>
//                   {formatSalesValue(paymentStatus.Complimentary)}
//                 </label>
//               </div>
//               {/* <div>
//               <label>
//                 <span> Split : </span>
//                 {formatSalesValue(paymentStatus.Split)}
//               </label>
//             </div> */}
//               <div>
//                 <label>
//                   <span> Discount Amount : </span>
//                   {formatSalesValue(dineinTabs.DiscountAmountSum)}
//                 </label>
//               </div>
//             </div>
//           )}
//         </div>
//         <hr className="hr-line" />
//       </Sidebar>
//     </div>
//   );
// };

// export default SidebarPro;








// import { useEffect, useState } from "react";
// import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";
// import Piechart from "../Charts/Piechart";
// import * as XLSX from "xlsx";
// import { formatSalesValue } from "../../utils/formatUtils";
// import { useFilter } from "../../context/FilterContext";

// const SidebarPro = ({
//   dineinTabs,
//   paymentStatus,
//   splitDetails,
//   startBillNum,
//   endBillNum,
//   FoodBeverageSum,
//   toggleArrow,
//   outlet,
//   creditOrders,
//   discountOrders,
//   complimentaryItems,
//   compLoading,
//   compError,
// }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [totalSplitCash, setTotalSplitCash] = useState(0);
//   const [totalSplitCreditCard, setTotalSplitCreditCard] = useState(0);
//   const [totalSplitMobilePayment, setTotalMobilePayment] = useState(0);

//   const { isServiceChecked } = useFilter();

//   let revenuePerGuest = 0;
//   if (!dineinTabs?.error) {
//     const netTotalSale = dineinTabs.netTOTALSALES;
//     const numGuest = dineinTabs.TotalGuests;
//     revenuePerGuest = netTotalSale / numGuest;
//   }

//   useEffect(() => {
//     if (Array.isArray(splitDetails)) {
//       splitDetails.forEach((payment) => {
//         if (payment.paymentMode === "Cash") {
//           setTotalSplitCash(payment.paymentAmount);
//         } else if (payment.paymentMode === "Credit Card") {
//           setTotalSplitCreditCard(payment.paymentAmount);
//         } else if (payment.paymentMode === "Mobile Payment") {
//           setTotalMobilePayment(payment.paymentAmount);
//         }
//       });
//     }
//   }, [splitDetails]);

//   const handleExport = () => {
//     if (!dineinTabs) return;

//     const data = [
//       ["Starting Bill No", startBillNum],
//       ["Ending Bill No", endBillNum || "-"],
//       ["Total Guests", dineinTabs.TotalGuests || "-"],
//       ["Revenue Per Guest", revenuePerGuest?.toFixed(2) || "-"],
//       [],
//       ["Total Sales", dineinTabs.TOTALSALES],
//       ["Dine-In", dineinTabs.DineInSALES],
//       ["Take-away", dineinTabs.TabSALES || 0],
//       [],
//       ["Total Net Sales", dineinTabs.netTOTALSALES],
//       ["Dine-In", dineinTabs.netDineInSALES],
//       ["Take-away", dineinTabs.netTabSALES || 0],
//       [],
//       ["Total VAT", dineinTabs.TotalVat],
//       ["Dine-In VAT", dineinTabs.DineInVAT],
//       ["Take-away VAT", dineinTabs.TabVAT || 0],
//       [],
//       ["Food Sale", dineinTabs.FoodSale],
//       ["Beverage Sale", dineinTabs.BeverageSale],
//       ["Others", dineinTabs.OtherSale || 0],
//       [],
//       ["Credit Card", parseInt(paymentStatus.CreditCard || 0) + totalSplitCreditCard],
//       ["Cash", parseInt(paymentStatus.Cash || 0) + totalSplitCash],
//       ["Mobile Payment", parseInt(paymentStatus.MobilePayment || 0) + totalSplitMobilePayment],
//       ["Credit", paymentStatus.Credit],
//       ["Complimentary", paymentStatus.Complimentary],
//       ["Discount", dineinTabs.DiscountAmountSum],
//     ];

//     const ws = XLSX.utils.aoa_to_sheet(data);
//     const colWidths = data[0].map((_, colIndex) => {
//       const maxLen = data.reduce((max, row) => {
//         const cell = row[colIndex];
//         const len = cell ? cell.toString().length : 0;
//         return Math.max(max, len);
//       }, 10);
//       return { wch: maxLen + 4 };
//     });
//     ws["!cols"] = colWidths;

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Summary");

//     const today = new Date().toLocaleDateString("en-CA");
//     const safeOutlet = (outlet || "Outlet")
//       .replace(/[^a-z0-9]/gi, "_")
//       .toLowerCase();
//     XLSX.writeFile(wb, `${safeOutlet}_sales_${today}.xlsx`);
//   };

//   return (
//     <div className="relative flex h-full">
//       {/* Toggle button — always visible */}
//       <button
//         onClick={() => {
//           setCollapsed((prev) => !prev);
//           toggleArrow?.();
//         }}
//         className="absolute left-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white shadow-md hover:bg-gray-50 transition-colors"
//       >
//         {collapsed ? (
//           <AiOutlineArrowLeft className="text-gray-600" />
//         ) : (
//           <AiOutlineArrowRight className="text-gray-600" />
//         )}
//       </button>

//       {/* Sidebar panel */}
//       <aside
//         className={`
//           h-full overflow-y-auto border-gray-200 bg-white transition-all duration-300 ease-in-out
//           ${collapsed ? "w-0 overflow-hidden opacity-0" : "w-72 opacity-100"}
//         `}
//       >
//         <div>
//           {!dineinTabs?.error && (
//             <div className="text-base">
//               <div className="flex justify-end p-2 mb-2">
//                 <button
//                   onClick={handleExport}
//                   className="rounded-md bg-indigo-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-indigo-700 transition-colors"
//                 >
//                   Export
//                 </button>
//               </div>

//               <div className="space-y-2 px-3 py-2.5">
//                 <div>
//                   <label>
//                     <span>Starting Bill No : </span>
//                     {startBillNum}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Ending Bill No : </span>
//                     {endBillNum === "" ? "-" : endBillNum}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Total No. of Guest : </span>
//                     {dineinTabs.TotalGuests === ""
//                       ? "-"
//                       : dineinTabs.TotalGuests}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Revenue Per Guest : </span>
//                     {revenuePerGuest === "" ? "-" : revenuePerGuest.toFixed(2)}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="space-y-2 px-3 py-2.5">
//                 <label>
//                   {" "}
//                   <span>Total Sales : </span> {formatSalesValue(dineinTabs.TOTALSALES)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInSALES)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {!dineinTabs.TabSALES ? "0" : formatSalesValue(dineinTabs.TabSALES)}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="space-y-2 px-3 py-2.5">
//                 <label>
//                   {" "}
//                   <span>Total Net Sales : </span>
//                   {formatSalesValue(dineinTabs.netTOTALSALES)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.netDineInSALES)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {!dineinTabs.netTabSALES ? "0" : dineinTabs.netTabSALES}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="space-y-2 px-3 py-2.5">
//                 <label>
//                   {" "}
//                   <span>Total VAT: </span>
//                   {formatSalesValue(dineinTabs.TotalVat)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInVAT)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {(dineinTabs.TabVAT = dineinTabs.TabVAT ?? "0")}
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="space-y-2 px-3 py-2.5">
//                 <label>
//                   {" "}
//                   <span>Service Charge : </span>
//                   {formatSalesValue(dineinTabs.TotalServiceCharge)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Dine-In : </span>
//                     {formatSalesValue(dineinTabs.DineInServiceCharge)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Take-away : </span>
//                     {
//                       (dineinTabs.TabServiceCharge =
//                         dineinTabs.TabServiceCharge ?? "0")
//                     }
//                   </label>
//                 </div>
//               </div>

//               <hr className="hr-line" />

//               <div className="py-3 px-1.5">
//                 <Piechart
//                   FoodBeverageSum={FoodBeverageSum}
//                   dineinTabs={dineinTabs}
//                 />
//               </div>

//               <hr className="hr-line" />

//               <div className="space-y-2 px-3 py-2.5">
//                 <label>
//                   {" "}
//                   <span>Food Sale : </span>
//                   {formatSalesValue(dineinTabs.FoodSale)}
//                 </label>
//                 <div>
//                   <label>
//                     <span>Beverage Sale : </span>
//                     {formatSalesValue(dineinTabs.BeverageSale)}
//                   </label>
//                 </div>
//                 <div>
//                   <label>
//                     <span>Others : </span>
//                     {!dineinTabs.OtherSale ? "0:00" : dineinTabs.OtherSale}
//                   </label>
//                 </div>
//               </div>
//               <hr className="hr-line" />
//             </div>
//           )}
//           {!paymentStatus?.error && (
//             <div className="space-y-2 px-3 py-2.5">
//               <div>
//                 <label>
//                   <span>Credit Card : </span>
//                   {formatSalesValue(
//                     Number(paymentStatus.CreditCard) + totalSplitCreditCard
//                   )}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span>Cash : </span>
//                   {formatSalesValue(Number(paymentStatus.Cash) + totalSplitCash)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span> Mobile Payment : </span>
//                   {formatSalesValue(Number(paymentStatus.MobilePayment) + totalSplitMobilePayment)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   {" "}
//                   <span>Credit Sale: </span>
//                   {formatSalesValue(paymentStatus.Credit)}
//                 </label>
//               </div>
//               <div>
//                 <label>
//                   <span>Complimentary : </span>
//                   {formatSalesValue(paymentStatus.Complimentary)}
//                 </label>
//               </div>
//               {/* <div>
//               <label>
//                 <span> Split : </span>
//                 {formatSalesValue(paymentStatus.Split)}
//               </label>
//             </div> */}
//               <div>
//                 <label>
//                   <span> Discount Amount : </span>
//                   {formatSalesValue(dineinTabs.DiscountAmountSum)}
//                 </label>
//               </div>
//             </div>
//           )}
//         </div>

//         <hr className="hr-line" />
//       </aside >
//     </div >
//   );
// };

// export default SidebarPro;












import { useCallback, useEffect, useState } from "react";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";
import * as XLSX from "xlsx";
import { useFilter } from "../../context/FilterContext";
import SidebarDetailModal from "./SidebarDetailModal";
import axios from "axios";
import SidebarDetails from "./SidebarDetails";

// ─── SidebarPro ──────────────────────────────────────────────────────────────

const SidebarPro = ({
  dineinTabs,
  paymentStatus,
  splitDetails,
  startBillNum,
  endBillNum,
  FoodBeverageSum,
  toggleArrow,
  outlet,
  creditOrders,
  discountOrders,
  startDate,
  endDate,
  url,
  token,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [totalSplitCash, setTotalSplitCash] = useState(0);
  const [totalSplitCreditCard, setTotalSplitCreditCard] = useState(0);
  const [totalSplitMobilePayment, setTotalMobilePayment] = useState(0);

  const [voidedLoading, setVoidedLoading] = useState(false);
  const [voidedError, setVoidedError] = useState(null);
  const [voidedOrders, setVoidedOrders] = useState([]);

  const [complimentaryItems, setComplimentaryItems] = useState([]);
  const [compLoading, setCompLoading] = useState(false);
  const [compError, setCompError] = useState(null);

  const { isServiceChecked } = useFilter();

  let revenuePerGuest = 0;
  if (!dineinTabs?.error) {
    const netTotalSale = dineinTabs.netTOTALSALES;
    const numGuest = dineinTabs.TotalGuests;
    revenuePerGuest = netTotalSale / numGuest;
  }

  // Derived net values adjusted for service charge toggle
  const adjustedNetTotal = isServiceChecked
    ? Number(dineinTabs?.netTOTALSALES || 0) - Number(dineinTabs?.TotalServiceCharge || 0)
    : Number(dineinTabs?.netTOTALSALES || 0);

  const adjustedNetDineIn = isServiceChecked
    ? Number(dineinTabs?.netDineInSALES || 0) - Number(dineinTabs?.DineInServiceCharge || 0)
    : Number(dineinTabs?.netDineInSALES || 0);

  const adjustedNetTab = isServiceChecked
    ? Number(dineinTabs?.netTabSALES || 0) - Number(dineinTabs?.TabServiceCharge || 0)
    : Number(dineinTabs?.netTabSALES || 0);

  useEffect(() => {
    if (Array.isArray(splitDetails)) {
      splitDetails.forEach((payment) => {
        if (payment.paymentMode === "Cash") {
          setTotalSplitCash(payment.paymentAmount);
        } else if (payment.paymentMode === "Credit Card") {
          setTotalSplitCreditCard(payment.paymentAmount);
        } else if (payment.paymentMode === "Mobile Payment") {
          setTotalMobilePayment(payment.paymentAmount);
        }
      });
    }
  }, [splitDetails]);

  const fetchVoidOrders = useCallback(
    async (start, end) => {
      try {
        setVoidedLoading(true);
        setVoidedError("");

        const response = await axios.post(
          `${url}/void-orders-today`,
          {
            startDate: start,
            endDate: end,
            outletName: outlet,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setVoidedOrders(response.data?.orders || []);
      } catch (err) {
        setVoidedError(
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Failed to fetch void orders."
        );
        setVoidedOrders([]);
      } finally {
        setVoidedLoading(false);
      }
    }, [url, token, outlet]);

  const fetchComplimentaryDetails = useCallback(
    async (start, end) => {
      try {
        setCompLoading(true);
        setCompError(null);

        const complimentaryItemsRes = await axios.post(
          `${url}/get-complimentary-items`,
          {
            token,
            outlet_name: outlet,
            from_date: start,
            to_date: end,
          }
        );

        setComplimentaryItems(complimentaryItemsRes?.data || {});
      } catch (error) {
        setCompError(
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to load complimentary items"
        );
      } finally {
        setCompLoading(false);
      }
    }, [url, token, outlet]);

  useEffect(() => {
    if (showModal) {
      fetchVoidOrders(startDate, endDate);
      fetchComplimentaryDetails(startDate, endDate);
    }
  }, [showModal, startDate, endDate, fetchVoidOrders, fetchComplimentaryDetails,]);

  const handleExport = () => {
    if (!dineinTabs) return;

    const data = [
      ["Starting Bill No", startBillNum],
      ["Ending Bill No", endBillNum || "-"],
      ["Total Guests", dineinTabs.TotalGuests || "-"],
      ["Revenue Per Guest", revenuePerGuest?.toFixed(2) || "-"],
      [],
      ["Total Sales", dineinTabs.TOTALSALES],
      ["Dine-In", dineinTabs.DineInSALES],
      ["Take-away", dineinTabs.TabSALES || 0],
      [],
      ["Total Net Sales", adjustedNetTotal],
      ["Dine-In", adjustedNetDineIn],
      ["Take-away", adjustedNetTab],
      [],
      ["Total VAT", dineinTabs.TotalVat],
      ["Dine-In VAT", dineinTabs.DineInVAT],
      ["Take-away VAT", dineinTabs.TabVAT || 0],
      ...(isServiceChecked
        ? [
          [],
          ["Service Charge", dineinTabs.TotalServiceCharge],
          ["Dine-In Service Charge", dineinTabs.DineInServiceCharge],
          ["Take-away Service Charge", dineinTabs.TabServiceCharge || 0],
        ]
        : []),
      [],
      ["Food Sale", dineinTabs.FoodSale],
      ["Beverage Sale", dineinTabs.BeverageSale],
      ["Others", dineinTabs.OtherSale || 0],
      [],
      ["Credit Card", parseInt(paymentStatus.CreditCard || 0) + totalSplitCreditCard],
      ["Cash", parseInt(paymentStatus.Cash || 0) + totalSplitCash],
      ["Mobile Payment", parseInt(paymentStatus.MobilePayment || 0) + totalSplitMobilePayment],
      ["Credit", paymentStatus.Credit],
      ["Complimentary", paymentStatus.Complimentary],
      ["Discount", dineinTabs.DiscountAmountSum],
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const colWidths = data[0].map((_, colIndex) => {
      const maxLen = data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 0;
        return Math.max(max, len);
      }, 10);
      return { wch: maxLen + 4 };
    });
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Summary");

    const today = new Date().toLocaleDateString("en-CA");
    const safeOutlet = (outlet || "Outlet")
      .replace(/[^a-z0-9]/gi, "_")
      .toLowerCase();
    XLSX.writeFile(wb, `${safeOutlet}_sales_${today}.xlsx`);
  };

  return (
    <>
      {/* Detail Modal */}
      {showModal && !dineinTabs?.error && (
        <SidebarDetailModal
          onClose={() => setShowModal(false)}
          dineinTabs={dineinTabs}
          paymentStatus={paymentStatus}
          splitDetails={splitDetails}
          startBillNum={startBillNum}
          endBillNum={endBillNum}
          outlet={outlet}
          creditOrders={creditOrders}
          discountOrders={discountOrders}
          complimentaryItems={complimentaryItems}
          compLoading={compLoading}
          compError={compError}
          voidedOrders={voidedOrders}
          voidedLoading={voidedLoading}
          voidedError={voidedError}
          totalSplitCash={totalSplitCash}
          totalSplitCreditCard={totalSplitCreditCard}
          totalSplitMobilePayment={totalSplitMobilePayment}
          isServiceChecked={isServiceChecked}
          startDate={startDate}
          endDate={endDate}
          revenuePerGuest={revenuePerGuest}
        />
      )}

      <div className="relative flex h-full">
        {/* Toggle button — always visible */}
        <button
          onClick={() => {
            setCollapsed((prev) => !prev);
            toggleArrow?.();
          }}
          className="absolute left-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white shadow-md hover:bg-gray-50 transition-colors"
        >
          {collapsed ? (
            <AiOutlineArrowLeft className="text-gray-600" />
          ) : (
            <AiOutlineArrowRight className="text-gray-600" />
          )}
        </button>

        {/* Sidebar panel */}
        <aside
          className={`
            h-full overflow-y-auto border-gray-200 bg-white border-r transition-all duration-300 ease-in-out shadow-lg
            ${collapsed ? "w-0 overflow-hidden opacity-0" : "w-72 opacity-100"}
          `}
        >
          <SidebarDetails
            dineinTabs={dineinTabs}
            startBillNum={startBillNum}
            endBillNum={endBillNum}
            revenuePerGuest={revenuePerGuest}
            adjustedNetTotal={adjustedNetTotal}
            adjustedNetDineIn={adjustedNetDineIn}
            adjustedNetTab={adjustedNetTab}
            isServiceChecked={isServiceChecked}
            FoodBeverageSum={FoodBeverageSum}
            paymentStatus={paymentStatus}
            totalSplitCreditCard={totalSplitCreditCard}
            totalSplitCash={totalSplitCash}
            totalSplitMobilePayment={totalSplitMobilePayment}
            setShowModal={setShowModal}
            handleExport={handleExport}
          />

          <hr className="hr-line" />
        </aside>
      </div>
    </>
  );
};

export default SidebarPro;